import ElmahErrorsComponent from "../Components/ElmahErrors/ElmahErrorsComponent"

function ElmahErrorsPage() {
    return (
        <ElmahErrorsComponent/>
    )
}

export default ElmahErrorsPage